import React, { memo, FC, CSSProperties, useEffect } from 'react';

import {
  Handle,
  Position,
  NodeProps,
  Connection,
  Edge,
} from 'react-flow-renderer';
import { useTranslation } from 'react-i18next';
import { DiamondBox } from '../Shapes';

const targetHandleStyle: CSSProperties = {
  background: 'transparent',
  border: 'none',
  left: -15,
};
const sourceHandleStyle: CSSProperties = {
  background: 'transparent',
  right: -580,
  // border: 'none',
};
const sourceHandleStyleB: CSSProperties = { ...targetHandleStyle, bottom: 10 };

const onConnect = (params: Connection | Edge) =>
  console.log('handle onConnect', params);

const Q5: FC<NodeProps> = ({ data, isConnectable }) => {
  const { t } = useTranslation();
  const [isEdgePathObserved, setIsEdgePathObserved] = React.useState(false);

  const observeEdgePaths = () => {
    // 创建观察器实例
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const target = mutation.target as HTMLElement;
        if (target.classList.contains('react-flow__edge-path')) {
          const strokeColor = getComputedStyle(target).stroke;
          if (strokeColor === 'rgb(255, 0, 0)') {
            // 注意颜色格式是rgb
            // console.log('发现红色路径:', {
            //   element: target,
            //   d: target.getAttribute('d'), // 获取路径数据
            //   style: target.getAttribute('style'),
            // });
            setIsEdgePathObserved(true);
          } else {
            setIsEdgePathObserved(false);
          }
        }
      });
    });

    // 配置观察选项
    const config = {
      attributes: true, // 监听属性变化
      attributeFilter: ['style'], // 只监听style属性
      subtree: true, // 监控所有后代节点
    };

    // 初始检查已存在的路径
    document.querySelectorAll('.react-flow__edge-path').forEach((path) => {
      observer.observe(path, config);
    });

    // 动态检测新增路径（适用于异步加载情况）
    const checkNewPaths = () => {
      document.querySelectorAll('.react-flow__edge-path').forEach((path) => {
        if (!(path as any)._observed) {
          observer.observe(path, config);
          (path as any)._observed = true;
        }
      });
    };

    // 每500ms检查一次新路径（根据实际情况调整频率）
    const intervalId = setInterval(checkNewPaths, 500);

    // 清理函数
    return () => {
      observer.disconnect();
      clearInterval(intervalId);
    };
  };

  useEffect(() => {
    const cleanup = observeEdgePaths();
    return cleanup; // 组件卸载时停止监听
  }, []);

  return (
    <DiamondBox>
      <Handle
        type="target"
        id="Q5-Target-L"
        position={Position.Left}
        style={targetHandleStyle}
        onConnect={onConnect}
      />
      <div className="txt">
        <span className="redBold">Q5.</span>
        <div dangerouslySetInnerHTML={{ __html: t('Q5') }} />
      </div>
      <div
        className="my_react-flow__edge-path"
        style={{
          color: isEdgePathObserved ? 'red' : 'black',
          position: 'absolute',
          width: 150,
          height: 126,
          borderTop: isEdgePathObserved ? '2px solid' : '1px solid',
          borderRight: isEdgePathObserved ? '2px solid' : '1px solid',
          top: 33,
          left: 114,
        }}
      ></div>
      {/* </Handle> */}
    </DiamondBox>
  );
};

export default memo(Q5);
